var DOM = {
    main: '.c-product-detail__benefits',
    showMore: '.js-benefits-seemore',
    listItem: '.benefit-item'
};


function showMore() {
    $(DOM.main +" "+DOM.listItem).removeClass('d-none');
    $(DOM.main +" "+ DOM.showMore).hide();
};